module.exports = __webpack_public_path__ + "static/media/age-xl.6b82ef06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/age-xl.jpg
// module id = 405
// module chunks = 13